import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { tracking_preview_model } from './tracking-model';
import {
  tracking_response_Shipmentstatus_model,
  tracking_response_model,
} from './tracking-item/tracking-item.model';
import { CanLoad } from '@angular/router';
import { StartupService } from '../core/startup.service';
import { CoreConfigService } from '../core/core.service';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TrackingService implements CanLoad {
  public ListResponse: tracking_response_model[] = [];

  public split_key: string = 'fHx8';

  constructor(
    private _StartupService: StartupService,
    private _CoreConfigService: CoreConfigService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.ResetListTracking();
  }

  CheckDecrypt(original_text: string): boolean {
    try {
      let decode_uri = decodeURIComponent(original_text);
      decode_uri = atob(decode_uri);
      return decode_uri.includes(this.split_key);
    } catch {
      return false;
    }
  }

  DecryptOldTrack(encrypt_text: string): string {
    try {
      let decode_uri = decodeURIComponent(encrypt_text);
      decode_uri = atob(decode_uri);
      if (decode_uri.includes(this.split_key)) {
        let split_data = decode_uri.split(this.split_key);
        return split_data.length > 2 ? split_data[2] : undefined;
      } else {
        return undefined;
      }
    } catch {
      return undefined;
    }
  }

  EncryptOldTrack(tracking: string[]): string {
    let _tmp_tracking =
      this._CoreConfigService.GetGUID() +
      this.split_key +
      this._CoreConfigService.GetGUID() +
      this.split_key +
      tracking.join(',') +
      this.split_key +
      this._CoreConfigService.GetGUID() +
      this.split_key +
      this._CoreConfigService.GetGUID();
    let b = btoa(_tmp_tracking);
    let encode_uri = encodeURIComponent(b);
    return encode_uri;
  }

  canLoad(): Promise<boolean> {
    if (isPlatformBrowser(this.platformId)) {
      return this._StartupService
        .GetRuntimeConfig()
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    }
    return null;
    // return null;
  }

  private ListTracking: tracking_preview_model[] = [];
  public ListTracking_found: number = 0;
  public ListTracking_notfound: number = 0;

  BuildNewListTracking(listtracking: string[]): tracking_preview_model[] {
    let result: tracking_preview_model[] = [];

    for (let index = 0; index < listtracking.length; index++) {
      const dt = listtracking[index];
      result.push({
        tracking_no: dt,
        hidden: false,
        isfound: false,
      } as tracking_preview_model);
    }
    return result;
  }

  ResetListTracking() {
    this.ListResponse = [];
    this.ListTracking = [];
    this.ListTracking_found = 0;

    this.ListTracking_notfound = 0;
  }
}
